<template>
  <div id="play" class="play" :class="cssModifierClass" @mousedown="mousedown" :data-browser-chrome-height="`${browserChromeHeight}`">
    <!-- <div class="debug">
      <p>
        window.innerHeight: <strong>{{ windowInnerHeight }}</strong>
      </p>
      <p>
        screen.height: <strong>{{ screenHeight }}</strong>
      </p>
      <p>
        browserChromeHeight: <strong>{{ browserChromeHeight }}</strong>
      </p>
      <p>
        navigator.userAgent: <strong>{{ navigatorUserAgent }}</strong>
      </p>
      <p>
        navigator.platform: <strong>{{ navigatorPlatform }}</strong>
      </p>
      <p>
        navigator.maxTouchPoints: <strong>{{ navigatorMaxTouchPoints }}</strong>
      </p>
    </div> -->
    <PlayHeader
      @shuffle-board="shuffleBoard"
      @play="play"
      @reset-board="resetBoard"
      @timer-stopped="setElapsedMs"
      @timeout="timeout"
      :categoryColor="categoryColor"
      :currentTilePrompt="currentTilePrompt"
      :numIncorrectClicks="numIncorrectClicks"
      :personalBestTotalDurationMs="personalBestTotalDurationMs"
      :playState="playState"
      :playStateCssModifier="playStateCssModifier"
      :promptPrefix="promptPrefix"
    />
    <PlayBoard
      :category="category"
      :categoryColor="categoryColor"
      :categoryCssModifier="categoryCssModifier"
      :imagesFolderName="imagesFolderName"
      :invertTileImagesInDarkMode="invertTileImagesInDarkMode"
      :layout="boardPortraitLayout"
      :mode="mode"
      :playState="playState"
      :playStateCssModifier="playStateCssModifier"
      :tileBackgroundColor="tileBackgroundColor"
      :tileBackgroundPosition="tileBackgroundPosition"
      :tileBackgroundSize="tileBackgroundSize"
      :tilePadding="tilePadding"
      :tileRadialGradientHexColor="tileRadialGradientHexColor"
      :tiles="tilesOnBoard"
      @tileClicked="tileClicked($event)"
    />
    <CountdownDisplay v-if="playState === 'COUNTING_DOWN'" :countDown="countDown" :categoryColor="categoryColor" />
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import shuffle from 'lodash/shuffle';
import find from 'lodash/find';
import debounce from 'lodash/debounce';
import firebase from 'firebase/app';
import 'firebase/auth';
import checkIfPersonalBestDocExists from './../helpers/checkIfPersonalBestDocExists';
import CountdownDisplay from './../components/CountdownDisplay';
import createPersonalBestDoc from './../helpers/createPersonalBestDoc';
import db from './../firebaseInit';
import formatDurationMs from './../helpers/formatDurationMs';
import getBoardSize from './../helpers/getBoardSize';
import getPreviousPersonalBest from './../helpers/getPreviousPersonalBest';
import incrementNumTimesBoardPlayed from './../helpers/incrementNumTimesBoardPlayed';
import isAndroid from './../helpers/isAndroid';
import isIOS from './../helpers/isIOS';
import PlayBoard from './../components/PlayBoard';
import PlayHeader from './../components/PlayHeader';
import router from './../router/index';
import updatePersonalBestDoc from './../helpers/updatePersonalBestDoc';
import zzfx from './../helpers/zzfx';
import {
  BOARD_MODES,
  CATEGORIES,
  COUNTDOWN_DURATION_SECS,
  INCORRECT_CLICK_PENALTY_DURATION_SECS,
  PATH_TO_TILE_IMAGES,
  PLAY_STATES,
  TIMEOUT_DURATION_SECS,
} from './../constants/globalConstants';
import {SUCCESSFUL_CLICK_SFX, UNSUCCESSFUL_CLICK_SFX, COUNTDOWN_TIMER_BING_SFX, COUNTDOWN_TIMER_BING_END_SFX, BOARD_COMPLETE_SFX} from './../constants/sfx';

const userVuexModule = createNamespacedHelpers('userVuexModule');

export default {
  name: 'play',
  title: 'Play',
  components: {
    CountdownDisplay,
    PlayBoard,
    PlayHeader,
  },
  data() {
    return {
      boardCreatedAt: null,
      boardId: null,
      boardPortraitLayout: null,
      categories: null,
      category: null,
      categoryColor: null,
      categoryCssModifier: null,
      completedDurationMs: 0,
      countDown: COUNTDOWN_DURATION_SECS,
      countDownSetTimeout: null,
      currentPromptIndex: 0,
      imagesFolderName: null,
      invertTileImagesInDarkMode: false,
      mode: null,
      name: null,
      navigatorMaxTouchPoints: navigator.maxTouchPoints,
      navigatorPlatform: navigator.platform,
      navigatorUserAgent: navigator.userAgent,
      numClicksTotal: 0,
      numCorrectClicks: 0,
      numIncorrectClicks: 0,
      personalBestTotalDurationMs: null,
      playState: null,
      playStateCssModifier: null,
      promoted: null,
      promptOrder: [],
      promptPrefix: null,
      screenHeight: 0,
      tileBackgroundColor: null,
      tileBackgroundPosition: null,
      tileBackgroundSize: null,
      tilePadding: false,
      tileRadialGradientHexColor: null,
      tilesAll: [],
      tilesEnabled: [],
      tilesOnBoard: [],
      windowInnerHeight: 0,
    };
  },
  watch: {
    numClicksTotal() {},
    numCorrectClicks() {},
    numIncorrectClicks() {},
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getBoardUsingSlug(to.params.boardIdOrSlug, next, vm);
    });
  },
  created() {
    this.categories = CATEGORIES;
    this.playState = PLAY_STATES.COMPONENT_CREATED.CONSTANT;
    this.playStateCssModifier = PLAY_STATES.COMPONENT_CREATED.CSS_MODIFIER;
    window.scrollTo(0, 0);

    window.onresize = debounce(() => {
      this.windowInnerHeight = window.innerHeight;
      this.screenHeight = screen.height;
    }, 100);

    this.windowInnerHeight = window.innerHeight;
    this.screenHeight = screen.height;
  },
  mounted() {},
  methods: {
    mousedown: function() {
      window.scrollTo(0, 0);
    },
    getBoardUsingSlug: function(boardIdOrSlug, next, vm) {
      db.collection('boards')
        .where('slug', '==', boardIdOrSlug)
        .get()
        .then(snapshot => {
          if (snapshot.size >= 1) {
            snapshot.forEach(doc => {
              vm.populateComponentWithBoardDataFromFirebase(doc.data());
            });
          } else {
            this.getBoardUsingId(boardIdOrSlug, next, vm);
          }
        });
    },
    getBoardUsingId: function(boardIdOrSlug, next, vm) {
      db.collection('boards')
        .where('boardId', '==', boardIdOrSlug)
        .get()
        .then(snapshot => {
          if (snapshot.size >= 1) {
            snapshot.forEach(doc => {
              vm.populateComponentWithBoardDataFromFirebase(doc.data());
            });
          } else {
            router.replace({name: 'dashboard'}).catch(err => {});
          }
        });
    },
    populateComponentWithBoardDataFromFirebase: function(data) {
      this.boardCreatedAt = data.boardCreatedAt;
      this.boardId = data.boardId;
      this.boardPortraitLayout = data.boardPortraitLayout;
      this.category = data.category;
      this.categoryColor = this.categories[data.category].COLOR;
      this.categoryCssModifier = this.categories[data.category].CSS_MODIFIER;
      this.imagesFolderName = data.imagesFolderName;
      this.invertTileImagesInDarkMode = data.invertTileImagesInDarkMode;
      this.mode = data.mode;
      this.name = data.name;
      this.promoted = data.promoted;
      this.promptPrefix = data.promptPrefix;
      this.tileBackgroundColor = data.tileBackgroundColor;
      this.tileBackgroundPosition = data.tileBackgroundPosition;
      this.tileBackgroundSize = data.tileBackgroundSize;
      this.tilePadding = data.tilePadding;
      this.tileRadialGradientHexColor = data.tileRadialGradientHexColor;
      this.$store.dispatch('SET_CURRENT_CATEGORY_ACTION', {currentCategory: this.category});
      this.loadTiles(this);
    },
    loadTiles: function(vm) {
      db.collection('boards')
        .doc(this.boardId)
        .collection('tiles')
        .get()
        .then(snapshot => {
          snapshot.docs.forEach(doc => {
            if (doc.data().prompt !== undefined && doc.data().prompt !== '' && doc.data().tileId !== undefined && doc.data().tileId !== '') {
              vm._data.tilesAll.push(doc.data());
            }
          });
          vm.tileDataLoaded();
          vm.populateBoard();
          vm.playState = PLAY_STATES.READY.CONSTANT;
          vm.playStateCssModifier = PLAY_STATES.READY.CSS_MODIFIER;
          getPreviousPersonalBest(this.boardId, personalBestTotalDurationMs => {
            this.personalBestTotalDurationMs = personalBestTotalDurationMs;
          });
        });
    },
    tileDataLoaded: function() {
      this.tilesAll = this.tilesAll.map((tile, index) => ({...tile, originalIndex: index}));
      this.tilesEnabled = this.tilesAll.filter(tile => tile.enabled);
    },
    populateBoard: function() {
      this.tilesEnabled = this.tilesEnabled.map(tile => ({...tile, clicked: false}));
      this.tilesOnBoard = shuffle(this.tilesEnabled).slice(0, this.boardSize);
      this.tilesOnBoard = this.tilesOnBoard.map(tile => ({...tile, clicked: false, numIncorrectClicks: 0}));
    },
    shuffleBoard: function() {
      this.tilesOnBoard = this.tilesOnBoard.map(tile => ({...tile, clicked: false, numIncorrectClicks: 0}));
      this.tilesOnBoard = shuffle(this.tilesOnBoard);
      this.promptOrder = shuffle(this.tilesOnBoard.map(tile => tile.tileId));
    },
    resetBoard: function() {
      this.countDown = COUNTDOWN_DURATION_SECS;
      this.playState = PLAY_STATES.READY.CONSTANT;
      this.playStateCssModifier = PLAY_STATES.READY.CSS_MODIFIER;
      this.numClicksTotal = 0;
      this.numCorrectClicks = 0;
      this.numIncorrectClicks = 0;
      this.currentPromptIndex = 0;
      this.tilesEnabled = this.tilesEnabled.map(tile => ({...tile, clicked: false}));
      this.tilesOnBoard = this.tilesOnBoard.map(tile => ({...tile, clicked: false, numIncorrectClicks: 0}));
    },
    tileClicked: function(tileId) {
      const clickedTile = find(this.tilesOnBoard, {tileId: tileId});
      this.numClicksTotal++;
      if (tileId === this.currentTileId) {
        clickedTile.clicked = true;
        this.numCorrectClicks++;
        this.currentPromptIndex++;
        if (this.getPlaySoundEffects) zzfx(...SUCCESSFUL_CLICK_SFX);
      } else {
        clickedTile.numIncorrectClicks++;
        this.numIncorrectClicks++;
        if (this.getPlaySoundEffects) zzfx(...UNSUCCESSFUL_CLICK_SFX);
      }
      if (this.numCorrectClicks === this.numTilesOnBoard) {
        this.playState = PLAY_STATES.COMPLETED.CONSTANT;
        this.playStateCssModifier = PLAY_STATES.COMPLETED.CSS_MODIFIER;
      }
    },
    play: function() {
      this.playState = PLAY_STATES.COUNTING_DOWN.CONSTANT;
      this.playStateCssModifier = PLAY_STATES.COUNTING_DOWN.CSS_MODIFIER;
      this.countDownTimer();
    },
    countDownTimer: function() {
      if (this.countDown > 0) {
        this.shuffleBoard();
        if (this.getPlaySoundEffects) zzfx(...COUNTDOWN_TIMER_BING_SFX);
        this.countDownSetTimeout = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      } else {
        this.playState = PLAY_STATES.PLAYING.CONSTANT;
        this.playStateCssModifier = PLAY_STATES.PLAYING.CSS_MODIFIER;
        if (this.getPlaySoundEffects) zzfx(...COUNTDOWN_TIMER_BING_END_SFX);
      }
    },
    setElapsedMs: function(elapsedMs) {
      this.completedDurationMs = elapsedMs;
      if (this.getPlaySoundEffects) zzfx(...BOARD_COMPLETE_SFX);
      this.gameEnded();
    },
    timeout: function() {
      console.log('timeout()');
      this.playState = PLAY_STATES.TIMEOUT.CONSTANT;
      this.playStateCssModifier = PLAY_STATES.TIMEOUT.CSS_MODIFIER;
    },
    gameEnded: function() {
      const penaltyDurationMs = INCORRECT_CLICK_PENALTY_DURATION_SECS * 1000 * this.numIncorrectClicks;
      const totalDurationMs = this.completedDurationMs + penaltyDurationMs;
      const pbObject = {
        accuracy: parseFloat(this.accuracy.toFixed(2)),
        averageCorrectClickDurationMs: parseFloat(this.averageCorrectClickDurationMs.toFixed(2)),
        boardId: this.boardId,
        boardName: this.name,
        completedDurationMs: this.completedDurationMs,
        numClicksTotal: this.numClicksTotal,
        numIncorrectClicks: this.numIncorrectClicks,
        numTilesOnBoard: this.numTilesOnBoard,
        penaltyDurationMs: penaltyDurationMs,
        totalDurationMs: totalDurationMs,
        unixTimestampSec: Math.floor(Date.now().toString() / 1000).toString(),
      };
      if (this.personalBestTotalDurationMs) {
        if (totalDurationMs < this.personalBestTotalDurationMs) {
          updatePersonalBestDoc(this.boardId, pbObject);
        } else {
          incrementNumTimesBoardPlayed(this.boardId);
        }
      } else {
        createPersonalBestDoc(this.boardId, pbObject);
      }
    },
  },
  computed: {
    ...userVuexModule.mapGetters(['userCanRead', 'userCanEdit', 'userCanCreate', 'userCanDelete', 'getPlaySoundEffects']),
    browserChromeHeight: function() {
      return this.screenHeight - this.windowInnerHeight;
    },
    getPathToTileImages: function() {
      return PATH_TO_TILE_IMAGES;
    },
    numTilesOnBoard: function() {
      return this.tilesOnBoard.length;
    },
    numTilesTotal: function() {
      return this.tilesAll.length;
    },
    numTilesDisabled: function() {
      return this.tilesAll.filter(tile => !tile.enabled).length;
    },
    numTilesEnabled: function() {
      return this.tilesAll.filter(tile => tile.enabled).length;
    },
    boardSize: function() {
      return getBoardSize(this.boardPortraitLayout);
    },
    averageCorrectClickDurationMs: function() {
      if (this.numCorrectClicks < this.numTilesOnBoard || this.completedDurationMs === 0) {
        return 0;
      } else {
        return this.completedDurationMs / this.numTilesOnBoard;
      }
    },
    cssModifierClass: function() {
      if (this.mode) {
        return `play--${BOARD_MODES[this.mode].CSS_MODIFIER} play--browser-chrome-height-${this.browserChromeHeight}`;
      } else {
        return `play--browser-chrome-height-${this.browserChromeHeight}`;
      }
    },
    currentTileId: function() {
      if (this.currentPromptIndex > this.numTilesOnBoard - 1) {
        return '';
      } else {
        return this.promptOrder[this.currentPromptIndex];
      }
    },
    currentTilePrompt: function() {
      const currentTile = find(this.tilesOnBoard, {tileId: this.currentTileId});
      if (currentTile) {
        return currentTile.prompt;
      } else {
        return '';
      }
    },
    accuracy: function() {
      if (!this.numClicksTotal || this.numClicksTotal === 0) {
        return 0;
      } else {
        return this.numCorrectClicks / this.numClicksTotal;
      }
    },
    accuracyFormatted: function() {
      return `${Math.floor(this.accuracy * 100)}%`;
    },
  },
  beforeDestroy() {
    clearTimeout(this.countDownSetTimeout);
    window.onresize = null;
  },
};
</script>

<style lang="scss" scoped>
.play {
  height: 100vh;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}

.debug {
  background-color: #fff;
  border: 1px solid red;
  color: #000;
  font-size: 1.3rem;
  left: 50%;
  margin: 0 auto;
  padding: 1rem;
  position: absolute;
  top: 17rem;
  transform: translateX(-50%);
  width: 28rem;
  z-index: 5;

  p {
    margin: 0 0 1rem 0;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
